<template>
  <div id="div2" style="text-align: left; height: 100%">
    <div style="margin-bottom: 10px; margin-left: 10px; font-weight: bold">
      {{ title }}
      <Button @click="addExportTask(select)" type="text">导出数据</Button>
    </div>
    <div style="clear: both"></div>
    <Table
      width="100%"
      :height="height - 110"
      :columns="columns2"
      :data="tableDate"
      highlight-row
      @on-row-click="rowData"
    >
      <template slot-scope="{ row, index }" slot="parkDuration">
        <Tooltip v-if="row.isPark" placement="left-start" theme="light">
          {{ row.parkDuration }}
          <div slot="content">
            <p>停车时长：{{ utils.minTime(row.parkDuration) }}</p>
            <p>开始停车：{{ row.startParkTime }}</p>
            <p>结束停车：{{ row.endParkTime }}</p>
          </div>
        </Tooltip>
        <span v-else>暂无</span>
      </template>
      <template slot-scope="{ row, index }" slot="direction">
        <Direction :direction="row.direction"></Direction>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="pageSize"
          :page-size-opts="[10, 20, 30, 50, 80]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <exportLocus ref="exportLocus"></exportLocus>
  </div>
</template>
<script>
import axios from "axios";
import Direction from "../common/Direction.vue";
import exportLocus from "../locus/export.vue"
var jindu;
export default {
  props: ["mapData", "height"],
  components: { Direction,exportLocus },
  data() {
    return {
      tableHeight: 0,
      fresh: false,
      modal: false,
      modal1: false,
      isFenxi: false, //是否分析模式
      columns2: [
        {
          type: "index",
          width: 70,
          align: "center",
          fixed: "left",
        },
        {
          title: "姓名",
          key: "personName",
          minWidth: 70,
          maxWidth: 130,
          tooltip: true,
        },
        {
          title: "设备号",
          key: "deviceNo",
          minWidth: 130,
          maxWidth: 200,
        },
        {
          title: "GPS时间",
          key: "gpsTime",
          align: "left",
          minWidth: 130,
          maxWidth: 130,
          tooltip: true,
        },
        {
          title: "上报时间",
          key: "reportTime",
          align: "left",
          minWidth: 130,
          maxWidth: 130,
          tooltip: true,
        },
        {
          title: "位置地址",
          key: "address",
          align: "left",
          width: 300,
          tooltip: true,
        },
        {
          title: "信号",
          key: "flag",
          align: "left",
          minWidth: 70,
          maxWidth: 130,
          tooltip: true,
          render: (h, data) => {
            return h(
              "div",
              { class: data.row.flag == 1 ? "ly-green" : "ly-gray" },
              data.row.flag == 1 ? "有" : "无"
            );
          },
        },
        {
          title: "速度/km/h",
          key: "speed",
          align: "left",
          minWidth: 70,
          maxWidth: 130,
          tooltip: true,
        },
        {
          title: "里程/km",
          key: "mileage",
          align: "left",
          minWidth: 70,
          maxWidth: 130,
          tooltip: true,
        },
        {
          title: "事件报告",
          key: "eventDesc",
          minWidth: 100,
          maxWidth: 200,
          tooltip: true,
        },
        {
          title: "高德经度(GCJ-02)",
          key: "returnX",
          minWidth: 160,
          maxWidth: 200,
        },
        {
          title: "高德纬度(GCJ-02)",
          key: "returnY",
          minWidth: 160,
          maxWidth: 200,
        },
        {
          title: "原始经度(WGS-84)",
          key: "orgX",
          minWidth: 160,
          maxWidth: 200,
        },
        {
          title: "原始纬度(WGS-84)",
          key: "orgY",
          minWidth: 160,
          maxWidth: 200,
        },
        
      ],
      title: "",
      tableDate: [],
      total: 0,
      tableDatedaochu: [],
      pageNumber: 1,
      pageSize: 50, //每页数量
      select: {},
    };
  },
  methods: {
    //当前行的数据
    rowData(data) {
      this.$emit("drawPoint", data);
    },
    getHistory(x) {
      this.select = x;

      let params = {
        deviceNo: this.select.deviceNo,
        endTime: this.select.end.getTime(),
        startTime: this.select.start.getTime(),
        pageSize: this.pageSize,
        pageNumber: this.pageNumber,
        returnCoord: 2, //返回坐标系（1-WGS84，2-GCJ-02，3-BD-09）,可用值:1,2,3
      };
      this.utils.loading(this, "加载中");
      var url;
      if (x.val == 1) {
        this.title = "轨迹数据列表";
        url = axios.lbs + "/locus/getPlyLocus";
      } else if (x.val == 3) {
        this.title = "全部原始轨迹数据表";
        url = axios.lbs + "/locus/getOrgLocus";
        ///cloud-common-server-lbs/locus/getOrgLocus
      }
      axios({
        method: "post",
        url: url,
        data: params,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        var data = res.data.data.dataList;
        console.log(res);
        var pointList = [];
        for (const i in data) {
          data[i].address = "";
          data[i].gpsTime = this.utils.time(data[i].gpsTime);
          data[i].reportTime = this.utils.time(data[i].recordTime);
          data[i].startParkTime =
            data[i].parkDuration == null
              ? ""
              : this.utils.time(data[i].gpsTime);

          data[i].endParkTime = this.utils.time(data[i].endParkTime);
          var obj = {
            x: data[i].orgX,
            y: data[i].orgY,
          };
          pointList.push(obj);
        }
        this.tableDate = data;
        this.total = res.data.data.total;
        if (this.total == 0) {
          return;
        }
        this.utils.jiexi(pointList).then((data) => {
          for (const i in data) {
            this.tableDate[i].address = data[i].address;
          }
        });
      });
    },
    //页码切换时触发
    changePage(x) {
      this.pageNumber = x;
      this.getHistory(this.select);
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.pageSize = x;
      his.getHistory(this.select);
    },
    addExportTask(v){
      v.tt='人员';
      this.$refs.exportLocus.reachData(v)
    }
  },
  watch: {
    height(v) {
      this.tableHeight = v;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/locusPeson/listAll.vue